import { render } from "./oap-iframe.vue?vue&type=template&id=7572cfca"
import script from "./oap-iframe.vue?vue&type=script&lang=js"
export * from "./oap-iframe.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__